import DialogLayout from '../common/dialog-layout';

function SalvageDialog({ open, onSave, onClose, onCancel, onViewReportClick, nextButton }) {

  const handleShowReport = () => {
    onSave();
  };

  const content = (
    <div>
      <div className='text-[21px] font-semibold text-gray-800 mb-4'>
        We found a salvage record associated with this VIN.
      </div>
      <div className='text-gray-600 mb-6'>
        This may indicate the vehicle has been significantly damaged or deemed a total loss.
      </div>
      <div className='text-gray-800 mb-4'>
        Would you like to continue and view the full report?
      </div>
      <span className='text-green-900 underline font-medium cursor-pointer' onClick={onViewReportClick}>
        View The Report
      </span>
    </div>
  )

  const footerProps = {
    primaryButton: {
      text: nextButton,
    },
    secondaryButton: {
      text: "Quit",
      onClick: onCancel
    }
  }

  return (
    <DialogLayout
      title={"Salvage Detected"}
      open={open}
      padding= 'py-8'
      text= 'text-[35px]'
      fullScreen={false}
      maxWidth="sm"
      content={content}
      onClose={onClose}
      disableOuterClose={true}
      onSubmit={handleShowReport}
      footerProps={footerProps}
    />
  );
}

export default SalvageDialog;
